import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { getAuthConfig, signInWithGoogle } from "../api";
import { renderGoogleButton } from "../googleAuth";
import { AlertIcon } from "./Icons";
/* global window */
export default function Login({ onSignedIn }) {
    const btnRef = useRef(null);
    const [error, setError] = useState(null);
    const [notConfigured, setNotConfigured] = useState(false);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const cfg = await getAuthConfig();
                if (cancelled)
                    return;
                if (!cfg.configured || !cfg.googleClientId) {
                    setNotConfigured(true);
                    return;
                }
                if (!btnRef.current)
                    return;
                await renderGoogleButton(btnRef.current, cfg.googleClientId, async (credential) => {
                    try {
                        setError(null);
                        const { user } = await signInWithGoogle(credential);
                        onSignedIn(user);
                    }
                    catch (e) {
                        setError(e.message);
                    }
                });
            }
            catch (e) {
                if (!cancelled)
                    setError(e.message);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [onSignedIn]);
    return (_jsx("div", { className: "login-wrap", children: _jsxs("div", { className: "login-card", children: [_jsxs("div", { className: "login-brand", children: ["Suade", _jsx("span", { className: "dot", children: "." })] }), _jsx("div", { className: "login-tag", children: "Workspace" }), _jsx("p", { className: "blurb", children: "Point-of-work AI for arbitration lawyers. Sign in to set up a matter, assemble your case theory, and generate a grounded first draft." }), notConfigured ? (_jsxs("div", { className: "error-banner", style: { textAlign: "left" }, children: [_jsx(AlertIcon, { size: 16 }), _jsxs("span", { children: ["Google sign-in isn't configured yet. Set ", _jsx("code", { children: "GOOGLE_CLIENT_ID" }), " on the server and reload."] })] })) : (_jsx("div", { className: "gbtn-holder", ref: btnRef })), error && (_jsxs("div", { className: "error-banner", style: { textAlign: "left" }, children: [_jsx(AlertIcon, { size: 16 }), _jsx("span", { children: error })] })), _jsx("div", { className: "login-foot", children: "By continuing you agree to Suade's terms of use." })] }) }));
}
